export default "__VITE_ASSET__BeUr3_2Q__"